<template>
  <div class="PageBox">
    <div class="ScrollBox Wallet">
      <van-field v-model="selectBank" type="text" :label="$t('wallet.label[0]')" :placeholder="$t('wallet.placeholder[0]')" size="large" readonly @click="showPicker=true" />
      <van-field v-model.trim="drawData.drawword" type="password" :label="$t('wallet.label[2]')" :placeholder="$t('wallet.placeholder[2]')" clearable size="large" />
      <div style="margin-top:10px; border-radius: 5px;background-color: #fff;">
        <p style="color: #000;padding-top: 10px;padding-left: 10px;padding-bottom: 20px;">{{$t('wallet.label[1]')}}</p>
        <!-- <van-field
          v-model=""
          required
          clearable
          label="用户名"
          icon="question-o"
          placeholder="请输入用户名"
          bind:click-icon="onClickIcon"
        /> -->
        
        <van-field v-model.trim="drawData.draw_money" type="number" :placeholder="$t('wallet.placeholder[1]')" clearable size="large" disabled>
        </van-field>
        <div style="color: #000;padding: 10px 10px 0 10px;">
			<span>{{$t('user.default[4]')}}：{{UserInfo.balance}}</span>
			<span v-if="UserInfo.vip_level!=1" style="margin-left: 5%;"  >{{$t('user.default[13]')}}：10%</span>
			<span style="float: right;">USDT：{{Number(drawData.draw_money/InitData.setting.usdt_rate||0).toLocaleString()}}</span>
		</div>
        <van-grid
          class="Menu"
          direction="vertical"
          :column-num="3"
          :border="false"
          gutter="10"
        >
          <van-grid-item v-for="(item,index) in list_xt" :key="index">
            <template #text>
              <van-button type="default" size="small" style="width: 80px;" :style="drawData.draw_money==Number(item)?
              {
                backgroundColor: '#FFF4F4',
                color: '#37774C',
                border: '1px solid #FF5656',
                fontSize: '18px',
				padding:'2px'
              }:{
                backgroundColor: '#fff',
                color:'#000',
                fontSize: '18px'
              }" @click="drawData.draw_money = item">{{item}}</van-button>
            </template>
          </van-grid-item>
        </van-grid>
        
        <div>
          <van-button round type="default" block style="background-color: #FF5656;" @click="submitDraw">{{$t('userSet.default[3]')}}</van-button>
        </div>
        <!-- <div style="color: black; text-align: center;margin: 10px;line-height: 30px;height: 70px;" v-html="$t('wallet.msg[2]')"></div> -->
      </div>
    
    
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="cardList"
        @confirm="onConfirm"
        @cancel="showPicker=false"
    :confirm-button-text="$t('bankCard.placeholder[3]')"
    :cancel-button-text="$t('bankCard.placeholder[4]')"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Wallet',
  components: {
  },
  props: ['walletType'],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsState: 1,
      tabsIndex: 0,
      taskTabs: [
        {type: 1, text: this.$t('wallet.default[3]')},
        // {type: 2, text: '转账记录'},
        {type: 3, text: this.$t('wallet.default[4]')}
      ],
      showTurn: false,
      showDraw: false,
      showPicker: false,
      selectBank: '',
      isSubmit: false,
      turnData: {
        username: '',
        turn_money: '',
        drawword: ''
      },
      drawData: {
        draw_type: 'bank',
        user_bank_id: '',
        draw_money: 100,
        // phone: '',
        // email: '',
        // ifsc: '',
        drawword: ''
      },
      list_xt:[]
    }
  },
  computed: {
    cardList() {
      let data = this.$store.state.BankCardList.flatMap(item=>item.bank_name+' '+item.card_no.replace(/^(.{4}).*(.{4})$/, '$1 **** $2'))
      // if(this.UserInfo.alipay){
      //   data.unshift(this.$t('wallet.default[7]')+this.UserInfo.alipay.replace(/^(.{4}).*(.{4})$/, '$1 **** $2'))
      // }
	  if(data.length > 0) {
		  return data;
	  } else {
		  this.$Dialog.Alert(this.$t('wallet.msg[1]'),()=>{
		    this.$router.push('/user/bankCard')
		  })
	  }
    },
  },
  watch: {
    $route(){
      if(this.walletType){
        this.tabsIndex  = this.taskTabs.findIndex(item=>item.type==this.walletType)
        this.tabsState = this.walletType
      }else{
        this.tabsState = 1
        this.tabsIndex = 0
      }
      this.getListData('init')
    }
  },
  created() {
    this.$Model.GetBankCardList()
    this.$parent.navBarTitle = this.$t('wallet.default[0]')
    this.listData = this.taskTabs.flatMap(item=>[''])
    if(this.walletType){
      this.tabsIndex  = this.taskTabs.findIndex(item=>item.type==this.walletType)
      this.tabsState = this.walletType
    }
    this.getListData('init')
    this.drawData.draw_money = Number(this.InitData.setting.min_w||100)
    this.list_xt = this.InitData.setting.tx_money.split(',')
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    goTurn(type) {
      if(this.UserInfo.is_fund_password!=1){
        this.$Dialog.Alert(this.$t('wallet.msg[0]'),()=>{
          this.$router.push('/user/info')
        })
      }else{
        if(type=='turn'){
          this.showTurn = true
        }else{
          if(this.cardList.length){
            this.showDraw = true
          }else{
            this.$Dialog.Alert(this.$t('wallet.msg[1]'),()=>{
              this.$router.push('/user/bankCard')
            })
          }
        }
      }
    },
    openInfo(id) {
      if(this.tabsIndex==0){
        this.$router.push(`/user/recharge/${id}`)
      }
    },
    onConfirm(value,index) {
      this.drawData.user_bank_id = this.BankCardList[index].id;
      this.drawData.ifsc = this.BankCardList[index].bank_branch_name;
      this.selectBank = value;
      this.showPicker = false;
    },
    submitDraw() {
      if(!this.drawData.user_bank_id){
        this.$Dialog.Toast(this.$t('wallet.placeholder[3]'));
        return;
      }
      if(!this.drawData.draw_money){
        this.$Dialog.Toast(this.$t('wallet.placeholder[1]'));
        return;
      }
      // if(!this.drawData.phone){
      //   this.$Dialog.Toast(this.$t('wallet.placeholder[4]'));
      //   return;
      // }
      // if(!this.drawData.email){
      //   this.$Dialog.Toast(this.$t('wallet.placeholder[5]'));
      //   return;
      // }
      // if(!this.drawData.ifsc){
      //   this.$Dialog.Toast(this.$t('wallet.placeholder[6]'));
      //   return;
      // }
      if(!this.drawData.drawword){
        this.$Dialog.Toast(this.$t('wallet.placeholder[2]'));
        return;
      }
      this.isSubmit = true;
      this.$Model.Draw(this.drawData,data=>{
        this.isSubmit = false;
        if(data.code==1){
          this.showDraw = false
          this.drawData = {
            draw_type: 'bank',
            user_bank_id: '',
            draw_money: Number(this.InitData.setting.min_w||100),
            // phone: '',
            // email: '',
            // ifsc: '',
            drawword: ''
          }
          this.selectBank = ''
          this.getListData('init')
        }
      })
    },
    // submitTurn() {
    //   if(!this.turnData.username){
    //     this.$Dialog.Toast("请输入转入用户");
    //     return;
    //   }
    //   if(!this.turnData.turn_money){
    //     this.$Dialog.Toast("请输入转账金额");
    //     return;
    //   }
    //   if(!this.turnData.drawword){
    //     this.$Dialog.Toast("请输入支付密码");
    //     return;
    //   }
    //   this.isSubmit = true;
    //   this.$Model.Transfer(this.turnData,data=>{
    //     this.isSubmit = false;
    //     if(data.code==1){
    //       this.showTurn = false
    //       this.turnData = {
    //         username: '',
    //         turn_money: '',
    //         drawword: ''
    //       }
    //       this.getListData('init')
    //     }
    //   })
    // },
    onLoad() {
      this.getListData('load')
    },
    changeTabs(index) {
      this.tabsState = this.taskTabs[index].type
      this.getListData('init')
      // this.$router.push(`/user/wallet/${this.tabsState}`)
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      if(this.tabsIndex==0){
        this.$Model.GetRechargeRecord({state: 0,page_no:this.pageNo},data=>{
          this.isLoad = false
          if(data.code==1){
            if(type=='load'){
              this.listData[this.tabsIndex] = this.listData[this.tabsIndex].concat(data.info);
            }else{
              this.listData[this.tabsIndex] = data.info
            }
            if(this.pageNo==data.data_total_page){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.listData[this.tabsIndex] = ''
            this.isFinished = true
          }
        })
      }else if(this.tabsIndex==1){
        this.$Model.GetDrawRecord({state: 0,page_no:this.pageNo},data=>{
          this.isLoad = false
          if(data.code==1){
            if(type=='load'){
              this.listData[this.tabsIndex] = this.listData[this.tabsIndex].concat(data.info);
            }else{
              this.listData[this.tabsIndex] = data.info
            }
            if(this.pageNo==data.data_total_page){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.listData[this.tabsIndex] = ''
            this.isFinished = true
          }
        })
      }else{
        this.$Model.FundDetails({trade_type: 11,page_no:this.pageNo},data=>{
          this.isLoad = false
          if(data.code==1){
            if(type=='load'){
              this.listData[this.tabsIndex] = this.listData[this.tabsIndex].concat(data.list);
            }else{
              this.listData[this.tabsIndex] = data.list
            }
            if(this.pageNo==data.data_total_page){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.listData[this.tabsIndex] = ''
            this.isFinished = true
          }
        })
      }
      
    },
    onRefresh() {
      this.getListData('init')
    },
  }
}
</script>
<style scoped>
.ScrollBox{
  background: #F4F5F7;
}
.van-pull-refresh{
  min-height: calc(100vh - 219px);
}
.Wallet .balance{
  background-color: #fff;
  color: #01bccf;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  padding: 16px 10px;
  line-height: 1;
  position: relative;
  z-index: 3;
}
.Wallet .tool{
  padding: 0 16px;
  position: relative;
  z-index: 2;
  width: 100%;
}
.Wallet .tool::before{
  content: '';
  display: block;
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: -50%;
}
.Wallet .tool>div{
  margin-top: 5px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 5px #888;
  overflow: hidden;
  width: 100%;
  position: relative;
  z-index: 2;
  padding: 0 5px;
  display: flex;
  align-items: center;
  padding: 20px;
}
.Wallet .tool a{
  flex: 1;
  text-align: center;
  font-size: 16px;
  color: #4087f1;
  line-height: 25px;
  font-weight: 600;
}
.Wallet .tool a+a{
  border-left: 1px #4087f1 solid;
}
.van-tabs{
  margin-top: 10px;
}
.van-tabs>>>.van-tabs__wrap{
  height: 36px;
}
.van-tabs>>>.van-tabs__nav--card{
  overflow: hidden;
  height: 36px;
  margin: 0;
}
.van-tabs>>>.van-tab{
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
}
.van-action-sheet__header {
  background-color: #fff;
  color: #333;
}
.van-action-sheet__content {
  background-color: #fff;
}
.Main .van-action-sheet {
  background-color: #fff;
}
</style>